import PropTypes from "prop-types";
import { Box, Grid, Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

const AuthFooter = (props: any = null) => {
  //for sample
  const { t } = useTranslation();
  return (
    <>
      <Grid className="livis-auth-footer" minWidth={"100%"}>
        <Grid item lg={12} md={12} sm={12} xs={12} className="livis-footer-copyright-wrap"  px={4}>
          <Link
            href="/app/terms-and-conditions"
            underline="always"
            className="livis-footer-terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Typography variant="subtitle2" component="span" color={"grey"}>
              {t("Terms and Conditions")}
            </Typography>
          </Link>
          <Typography
            variant="subtitle2"
            component="span"
            className="livis-footer-copyright-text"
            align="center"
          >
            &#169; <span>LIN</span>
            <span>CODE</span> <span>{new Date().getFullYear()}</span>
          </Typography>
                    <Typography
            variant="subtitle2"
            component="span"
            className="livis-footer-confidential"
            fontWeight="bold"
          >
            <i>{t("CONFIDENTIAL")}</i>
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default AuthFooter;

